import React from "react";
import { MissionFormProps } from "../types";
import {
  HelperTextIcon,
  MissionNameHelperMessage,
  MissionNameHelperText,
  MissionNameInputContainer,
  MissionNameInputContent,
  MissionNameInputField,
  MissionNameInputWrapper,
  MissionNameLabel,
} from "../styles";
import { ReactComponent as AdditionalInfoIconSvg } from "../assets/additionalInfo.svg";

export const MissionForm: React.FC<MissionFormProps> = ({
  missionName,
  onMissionNameChange,
  children,
  readOnly = false,
}) => {
  return (
    <>
      <MissionNameInputContainer>
        <MissionNameLabel>Mission Name</MissionNameLabel>
        <MissionNameInputWrapper>
          <MissionNameInputContent>
            <MissionNameInputField
              type="text"
              placeholder="Mission Name goes here"
              value={missionName}
              maxLength={25}
              disabled={readOnly}
              readOnly={readOnly}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                !readOnly && onMissionNameChange(e.target.value)
              }
            />
          </MissionNameInputContent>
        </MissionNameInputWrapper>
      </MissionNameInputContainer>
      <MissionNameHelperText>
        <HelperTextIcon>
          <AdditionalInfoIconSvg />
        </HelperTextIcon>
        <MissionNameHelperMessage>
          Missions name limited to 25 characters
        </MissionNameHelperMessage>
      </MissionNameHelperText>
      {children}
    </>
  );
};
